import api from './api.service';

class EcuService {

    static async getBrands(search, page) {
        const params = {
            search: search,
            page: page
        }
        const res = await api.get('ecu/brands', params)
        try {
            return res.data;
        } catch (err) {
            return err;
        }
    }
    static async getEcus(search, page, brand) {
        const params = {
            search: search,
            brand: brand,
            page: page
        }
        const res = await api.get('ecu', params)
        try {
            return res.data;
        } catch (err) {
            return err;
        }
    }
}
export default EcuService;